import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';

function PageHeader() {
  const userData = useSelector((store: RootState) => store.user.userDetails);

  const user = {
    savedCards: 0,
    name: `${userData.FirstName} ${userData.LastName}`,
    coverImg: '/static/images/placeholders/covers/7.jfif',
    avatar: '/static/images/avatars/4.jpg',
    description: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, 
    by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage`,
    jobtitle: userData.UserRole === 'Vendor' ? 'User' : userData.UserRole,
    followers: '1'
  };

  return (
    <>
      <Typography variant="h3" component="h3" gutterBottom>
        Township Configuration
      </Typography>
      <Typography variant="subtitle2">
        {user.name}, welcome to the township configuration panel. Here, you can configure details such as the theme, 
        approver, finance charges, notifications, and manage users.
      </Typography>
    </>
  );
}

export default PageHeader;
